import { combineReducers } from 'redux';

import { default as businessAddress } from './businessAddress';
import { default as isDataCleanupComplete } from './isDataCleanupComplete';
import { default as isDiscarding } from './isDiscarding';
import { default as isPreviewOpen } from './isPreviewOpen';
import { default as jobCreationInProgressCount } from './jobCreationInProgressCount';
import { default as progress } from './progress';
import { default as queryParams } from './queryParams';
import { default as thinking } from './thinking';
import { default as withDraftId } from './withDraftId';

export default combineReducers({
  businessAddress,
  isDataCleanupComplete,
  isDiscarding,
  isPreviewOpen,
  jobCreationInProgressCount,
  progress,
  queryParams,
  thinking,
  withDraftId,
});
